<template>
  <div>
    <event-section-heading
      v-show="isLoading || events.length > 0"
      :target-label="targetLabel"
    />
    <swiper-carousel
      v-if="events.length > 0"
      :events="events"
    />
    <dummy-carousel v-else />
  </div>
</template>

<script>
import { RepositoryFactory } from '../../entry/api/inside/repository_factory'
import EventSectionHeading from '../events/section_heading'
import SwiperCarousel from '../events/carousel'
import DummyCarousel from '../events/dummy_carousel'
import * as Sentry from '@sentry/vue'

export default {
  name: 'EventTagsEvents',
  components: {
    EventSectionHeading,
    SwiperCarousel,
    DummyCarousel
  },
  props: {
    targetLabel: {
      type: String,
      required: true
    },
    eventTagIds: {
      type: Array,
      required: true
    },
    excludeEventIds: {
      type: Array,
      required: false,
      default: null
    }
  },
  data () {
    return {
      isLoading: true,
      events: []
    }
  },
  created () {
    const EventTagsFactory = RepositoryFactory.get('event_tags')
    EventTagsFactory.getEvents(this.eventTagIds, this.excludeEventIds)
      .then((response) => {
        this.events = response.data.events
      })
      .catch((error) => {
        Sentry.captureException(error)
      })
      .finally(() => {
        this.isLoading = false
      })
  }
}
</script>
